var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneys(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6906 7.97135V12.6922C17.6906 15.5155 16.0772 16.7255 13.6572 16.7255H5.59973C5.18723 16.7255 4.79307 16.6889 4.4264 16.6064C4.19724 16.5697 3.97724 16.5056 3.77558 16.4322C2.40058 15.9189 1.56641 14.7272 1.56641 12.6922V7.97135C1.56641 5.14802 3.17973 3.93805 5.59973 3.93805H13.6572C15.7106 3.93805 17.1864 4.80888 17.5806 6.79804C17.6447 7.16471 17.6906 7.54052 17.6906 7.97135Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4399 10.7215V15.4423C20.4399 18.2657 18.8266 19.4756 16.4066 19.4756H8.34911C7.67078 19.4756 7.05662 19.384 6.52496 19.1823C5.43412 18.779 4.69161 17.9448 4.42578 16.6065C4.79245 16.689 5.18661 16.7256 5.59911 16.7256H13.6566C16.0766 16.7256 17.6899 15.5157 17.6899 12.6923V7.97146C17.6899 7.54063 17.6533 7.15566 17.58 6.79816C19.3216 7.16482 20.4399 8.39313 20.4399 10.7215Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62314 12.7563C10.9597 12.7563 12.0432 11.6728 12.0432 10.3363C12.0432 8.99974 10.9597 7.91626 9.62314 7.91626C8.28661 7.91626 7.20312 8.99974 7.20312 10.3363C7.20312 11.6728 8.28661 12.7563 9.62314 12.7563Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37891 8.3197V12.3531",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8672 8.31995V12.3533",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneys);
export default __webpack_public_path__ + "static/media/moneys.73478f96842f10e4161674cd75679d2b.svg";
export { ForwardRef as ReactComponent };